// extracted by mini-css-extract-plugin
export default {"grid":"Layout_grid__Y22iu","content":"Layout_content__BestJ"};